import type { ReactNode } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

/*
  Replaces window.confirm for destructive actions.

  Two reasons beyond appearance. A native confirm cannot say what will actually
  happen — "Students in this group will become ungrouped" is the part that
  matters and it does not fit in a browser dialog's voice. And it blocks the
  whole thread, so the button behind it cannot show that the request is in
  flight, which is how people click Remove twice.
*/
export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  body,
  confirmLabel = 'Confirm',
  loading,
  destructive = true,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  body: ReactNode;
  confirmLabel?: string;
  loading?: boolean;
  destructive?: boolean;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant={destructive ? 'danger' : 'primary'}
            onClick={onConfirm}
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="text-[12px] leading-relaxed text-muted-foreground">{body}</div>
    </Modal>
  );
}
